import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import { TABLET_WIDTH } from "~/assets/js/Helpers/viewportExports";

const ProductsSlider = ({ children }) => {
    const sliderConfig = {
        className: "product-slider",
        slidesToShow: 4.125,
        slidesToScroll: 1,
        lazyLoad: false,
        infinite: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3.125,
                },
            },
            {
                breakpoint: TABLET_WIDTH,
                settings: {
                    slidesToShow: 2.5,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.25,
                },
            },
        ],
    };

    return <Slider {...sliderConfig}>{children}</Slider>;
};

ProductsSlider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default ProductsSlider;
